var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useContext } from "react";
import { AuthContext } from "../auth";
import { PersonaPathEnum, } from "@/shared/domain/entities/entity-persona";
export var ProductContext = React.createContext({
    loading: true,
    currentSkus: {
        otherSubscriptions: [],
        possiblesCrossSell: [],
        softwares: [],
    },
    entityProductsPlatforms: [],
    entityWalletPlatforms: [],
});
export var ProductProvider = function (_a) {
    var _b;
    var children = _a.children, contractDatasource = _a.contractDatasource, entityDatasource = _a.entityDatasource;
    var clientWallets = useContext(AuthContext).clientWallets;
    var clientRockId = (_b = clientWallets === null || clientWallets === void 0 ? void 0 : clientWallets[0]) === null || _b === void 0 ? void 0 : _b.rockId;
    var _c = useState(true), loading = _c[0], setLoading = _c[1];
    var _d = useState({
        otherSubscriptions: [],
        possiblesCrossSell: [],
        softwares: [],
    }), currentSkus = _d[0], setCurrentSkus = _d[1];
    var _e = useState([]), entityProductsPlatforms = _e[0], setEntityProductsPlatforms = _e[1];
    var _f = useState([]), entityWalletPlatforms = _f[0], setEntityWalletPlatforms = _f[1];
    var removePossibleCrossSell = function (currentSkus) {
        var productsToRemove = ["iclips", "studio 2.0"];
        var possiblesCrossSell = currentSkus.possiblesCrossSell.filter(function (possibleCrossSell) {
            return !productsToRemove.includes(possibleCrossSell.description.toLowerCase());
        });
        return __assign(__assign({}, currentSkus), { possiblesCrossSell: possiblesCrossSell });
    };
    var requestCurrentSkus = function () {
        setLoading(true);
        contractDatasource
            .getCurrentSkus(clientRockId)
            .then(function (data) {
            setCurrentSkus(removePossibleCrossSell(data));
        })
            .finally(function () { return setLoading(false); });
    };
    var requestEntityProductsPlatforms = function () {
        setLoading(true);
        entityDatasource
            .getPersonaPlatforms(clientRockId, PersonaPathEnum.clients)
            .then(function (data) {
            setEntityProductsPlatforms(data);
        })
            .finally(function () { return setLoading(false); });
    };
    var requestEntityProductsFromWallet = function () {
        setLoading(true);
        var products = [];
        for (var _i = 0, clientWallets_1 = clientWallets; _i < clientWallets_1.length; _i++) {
            var wallet = clientWallets_1[_i];
            entityDatasource
                .getPersonaPlatforms(wallet.rockId, PersonaPathEnum.clients)
                .then(function (data) { return data.filter(function (item) { return item.externalId; }); })
                .then(function (filteredData) { return products.push(filteredData); });
        }
        setEntityWalletPlatforms(products);
        setLoading(false);
    };
    useEffect(function () {
        if (!clientRockId)
            return;
        requestCurrentSkus();
        requestEntityProductsPlatforms();
        requestEntityProductsFromWallet();
    }, [clientRockId]);
    return (React.createElement(ProductContext.Provider, { value: {
            loading: loading,
            currentSkus: currentSkus,
            entityProductsPlatforms: entityProductsPlatforms,
            entityWalletPlatforms: entityWalletPlatforms,
        } }, children));
};
